import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{attrs:{"color":_vm.status.color,"dark":"","x-small":""}},[_c('strong',[_vm._v(_vm._s(_vm.status.texto))])])
}
var staticRenderFns = []

export { render, staticRenderFns }